import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, listFilesUploaded, readAllTenant, sendDataMohGenerate, changeViewForms } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';
import './MohForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faSave, faTimes, faMusic } from '@fortawesome/free-solid-svg-icons';

function MusicOnHoldCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({
    name: "",
    mode: "",
    directory: "",
    accountcode: "vgs",
    sort: "",
  });
  const [disableButton, setDisableButton] = useState(true);
  const [disableMusic, setDisableMusic] = useState(true);
  const [moh, setMohData] = useState({ name: '', tenant: '' });
  const [tenants, setTenants] = useState([]);
  const [musicSelected, setMusicSelected] = useState([]);
  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const fetchTenants = async (idtenant) => {
    let tenantsFetched = await readAllTenant();
    tenantsFetched = idtenant.includes('vgs') ? tenantsFetched : tenantsFetched.filter((tenant) => idtenant.includes(tenant.short_name));
    if (!tenantsFetched) return;
    setTenants(tenantsFetched);
    return;
  };

  const fetchMohList = async (idtenant) => {
    let fetchMohData = await listFilesUploaded();
    setMohData(fetchMohData);
    return;
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    await fetchTenants(idtenant);
    await fetchMohList(idtenant);
    return setLoading(false);
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const valuesAnalyse = (data) => {
    const { name, accountcode, mode, sort } = data;
    if(name.length > 0 && accountcode.length > 0 && mode.length > 0 && sort.length > 0) setDisableButton(false);
    if(mode === 'playlist' && !data.hasOwnProperty('music')) setDisableButton(true);
    if(mode === 'playlist' && data.hasOwnProperty('music')) setDisableButton(false);
    return;
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    if (name === 'mode' && value === 'files') setDisableMusic(true);
    if (name === 'mode' && value === 'playlist') setDisableMusic(false);
    if (name === 'accountcode') moh.hasOwnProperty(value) ? setMusicSelected(moh[value].moh) : setMusicSelected([]);
    setValues((prevState) => {
      const setRealValues = { ...prevState, [name]: value };
      if (name === 'mode' && value === 'files') delete setRealValues.music;
      valuesAnalyse(setRealValues);
      return setRealValues;
    });
    return;
  };

  const analyseDataMohPreSend = () => {
    const realValues = values;
    realValues.name = `moh-${realValues.name}-${realValues.accountcode}`;
    if (realValues.mode === 'files') realValues.directory = `/opt/vigoscloud/api/uploads/moh/${realValues.accountcode}`;
    if (realValues.mode === 'playlist') {
        realValues.entry = `/opt/vigoscloud/api/uploads/moh/${realValues.accountcode}/${realValues.music}`;
        realValues.position = 0;
        realValues.directory = '';
      };
    return realValues;
  };

  const sendDataInternalMohGenerate = async () => {
    const valuesToSend = analyseDataMohPreSend();
    const fetchSendMoh = await sendDataMohGenerate(valuesToSend); 
    toggleIsChangeFormElements('alert-create-tenant', 'is-hidden');

    const result = Object.keys(fetchSendMoh).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-tenant');
      setTimeout(() => {
        return window.location.reload();
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, []);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div className="moh-form-container">
          <div className="moh-form-header">
            <div className="moh-form-title-wrapper">
              <svg className="moh-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3" />
              </svg>
              <div>
                <h1 className="moh-form-title">Nova Música de Espera</h1>
                <p className="moh-form-subtitle">Adicione uma nova música de espera ao sistema</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-create-tenant" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-create-tenant')}>×</button>
              </div>
              <div className="alert-body">
                Não é possível criar música de espera com os campos abaixo não preenchidos.
                <br />
                Por favor, verifique os dados e clique novamente no botão <strong>Criar Música de Espera</strong> 
              </div>
            </div>

            <div id="error-create-tenant" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#error-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível adicionar a música de espera!
                <br />
                Verifique se a música de espera já existe!
              </div>
            </div>

            <div id="success-create-tenant" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-create-tenant')}>×</button>
              </div>
              <div className="alert-body">
                Música de espera adicionada com <strong>sucesso</strong>!<br/>
              </div>
            </div>
          </div>

          <form name="create-form" id="create-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-card">
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Nome</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="name" 
                      type="text" 
                      onChange={(e) => handleChangeValues(e.target)} 
                      placeholder="Insira o nome da música de espera" 
                    />
                    <span name="name-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>
                
                <div className="form-field">
                  <label className="form-label">Cliente</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="accountcode" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      {tenants.map((tenant) => (
                        <option key={`${tenant.accountcode}-${tenant.name}`} value={tenant.short_name}>{tenant.name}</option>
                      ))}
                    </select>
                    <span name="accountcode-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Tipo</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="mode" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="files">Ler Pasta</option>
                      <option value="playlist">Música Única</option>
                    </select>
                    <span name="mode-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Ordenar</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="sort" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="name">Nome</option>
                      <option value="random">Aleatório</option>
                    </select>
                    <span name="sort-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Música</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="music" 
                      onChange={(e) => handleChangeValues(e.target)} 
                      disabled={disableMusic}
                    >
                      <option value="">Selecione</option>
                      {musicSelected.map((music) => (
                        <option key={music} value={music.split('.')[0]}>{music.split('.')[0]}</option>
                      ))}
                    </select>
                    <span name="music-invalid-data" className='form-error is-hidden'>Campo obrigatório!</span>
                  </div>
                </div>
              </div>

              <div id="button-send-form" className="form-actions">
                <Link to="/config/musica-de-espera" className="btn-cancel">
                  <FontAwesomeIcon icon={faTimes} />
                  Cancelar
                </Link>
                <button 
                  className="btn-submit" 
                  type="submit" 
                  onClick={() => sendDataInternalMohGenerate()} 
                  disabled={disableButton}
                >
                  <FontAwesomeIcon icon={faSave} />
                  Criar Música de Espera
                </button>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  );
}

export default MusicOnHoldCreate;
